import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Visibility from "@material-ui/icons/Visibility";
import history from "../../../../history";
import { useStyles } from "components/layout/CommonStyles";
import { useTranslation } from "react-i18next";

export function TableAction({ type, path }) {
  const [t] = useTranslation();
  const classes = useStyles();

  const goTo = () => {
    history.push(path);
  };

  const getTitle = () => {
    switch (type) {
      case "view":
        return t("GENERAL.view");
      case "edit":
        return t("GENERAL.edit");
      default:
        return "";
    }
  }

  const getIcon = () => {
    switch (type) {
      case "view":
        return <Visibility />;
      case "edit":
        return <Edit />;
      default:
        return null;
    }
  }

  return (
    <React.Fragment>
      <Tooltip title={getTitle()} placement="top">
        <span>
          <IconButton
            className={classes.iconsTableActions}
            onClick={goTo}
            disabled={false}
          >
            {getIcon()}
          </IconButton>
        </span>
      </Tooltip>
    </React.Fragment>
  );
}

export default TableAction;
